import React, { useMemo } from "react";
import {
  ContentLayout,
  HeaderBreadcrumbs,
  usePermission,
} from "../../../shared";
import {
  ActiveMembers,
  RACTDetails,
  RACTLoadingIconButton,
  RACTStores,
} from "../components";
import { useRACT } from "../hooks";
import { BirthdayCouponUsageHistoryV2 } from "../../BirthdayCouponsV2";
import { LedgerAccountsList } from "../../Configurations/components";
import { Button, Chip, Stack } from "@mui/material";
import PlayIconBlue from "../../../assets/images/Icons/ic_blue_play.svg";
import { useNavigate } from "react-router-dom";

const ractStatusConfig = {
  1: {
    label: "Draft",
    color: "primary",
    variant: "outlined",
    sx: { bgcolor: "#1560D414", border: "none !important" },
  },
  2: {
    label: "Active",
    color: "success",
    variant: "outlined",
    sx: { border: "none !important" },
  },
  3: {
    label: "Paused",
    color: "success",
  },
};

export const RACT = () => {
  const { state, showAlert, fetchRACTDetails } = useRACT();
  const navigate = useNavigate();
  const isEditable = usePermission("coupon-modify");
  const statusConfig = ractStatusConfig[state.details?.active];

  const tabs = useMemo(
    () => [
      {
        label: "Details",
        value: "1",
        panel: <RACTDetails state={state} />,
      },
      {
        label: "Usage History",
        value: "2",
        panel: (
          <BirthdayCouponUsageHistoryV2
            couponId={state.details?.id}
            dateFilterLabel="Date Range"
            focusedTab={{ label: "ract", value: "2" }}
          />
        ),
      },
      {
        label: "Active Members",
        value: "3",
        panel: <ActiveMembers />,
      },
      {
        label: "Stores",
        value: "4",
        panel: (
          <RACTStores
            couponId={state.details?.id}
            stores={state.details?.stores}
            isLoading={state.isLoading}
            onRefresh={fetchRACTDetails}
          />
        ),
      },
      {
        label: "Accounts",
        value: "5",
        panel: (
          <LedgerAccountsList type="promotion" b_id={state.details?.id} />
        ),
      },
    ],
    [state.details, state.isLoading],
  );

  return (
    <ContentLayout
      title={"RACT"}
      breadcrumbs={
        <HeaderBreadcrumbs
          links={[{ name: "Dashboard", href: "/" }, { name: "RACT" }]}
        />
      }
      chipType="other"
      statusContent={
        statusConfig && (
          <Chip
            label={statusConfig.label}
            color={statusConfig.color}
            variant={statusConfig.variant}
            size="small"
            sx={statusConfig.sx}
          />
        )
      }
      rightContent={
        isEditable && (
          <Stack direction="row" gap="16px">
            {state.details?.active && (
              <>
                {(ractStatusConfig[state.details.active].label === "Draft" ||
                  ractStatusConfig[state.details.active].label ===
                    "Paused") && (
                  <RACTLoadingIconButton
                    loading={state.publishingOrUnpublishing}
                    onClick={() => showAlert({ status: "Publish" })}
                    title="Publish"
                  >
                    <img src={PlayIconBlue} alt="publish" />
                  </RACTLoadingIconButton>
                )}
                {ractStatusConfig[state.details.active].label === "Active" && (
                  <RACTLoadingIconButton
                    loading={state.publishingOrUnpublishing}
                    onClick={() => showAlert({ status: "Unpublish" })}
                    title="Unpublish"
                  >
                    <img
                      src="/icons/play_icon.svg"
                      alt="Unpublish"
                      width="20px"
                      height="20px"
                    />
                  </RACTLoadingIconButton>
                )}
              </>
            )}

            <Button
              type="button"
              size="medium"
              variant="contained"
              onClick={() => navigate("edit")}
            >
              Edit
            </Button>
          </Stack>
        )
      }
      tabProps={{
        label: "ract",
        list: tabs,
      }}
    />
  );
};
